module.exports = __webpack_public_path__ + "img/user-avatar.feeb8d7f.png";